import { Injectable } from "@angular/core";

// Declare google as a global variable
declare const google: any;
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map, Observable, of, tap, Subject } from "rxjs";
import { Review } from "../pages/landing/landing.component";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class ClientService {
    
    private TAXI_BLADI_URL = environment.apiUrl;
    private WALLET_BLADI_URL = environment.walletBladiUrl;
    private COMMERCE_BACKEND_URL=environment.commerceUrl+"/ecommerce/"

    // Observable Subject pour annuler la recherche
    private cancelSearchSubject = new Subject<string>();
    public cancelSearch$ = this.cancelSearchSubject.asObservable();

    // Observable Subject pour la liste des drivers
    private listDriversAcceptedSubject = new Subject<any[]>();
    public listDriversAccepted$ = this.listDriversAcceptedSubject.asObservable();


  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient, private router: Router) {

  }

  requestOtp(body: any): Observable<any>{
    return this._httpClient.post<any>(`${this.TAXI_BLADI_URL}/auth/request-otp`,body)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('OTP sent successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error sending OTP');
        return of(null);
      })
    );
  }
  verifyOtp(body: any): Observable<any>{
    return this._httpClient.post<any>(`${this.TAXI_BLADI_URL}/auth/verify-otp`,body)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('OTP verified successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error verifying OTP');
        return of(null);
      })
    );
  }
  

  completSignUp(body: any): Observable<any>{
    return this._httpClient.post<any>(`${this.TAXI_BLADI_URL}/auth/mobile-signup`,body)
    .pipe(
      tap((response) => {
        if (response.success) {

          console.log("COMPLET SIGNUP RESPONSE ===> ", response);
          localStorage.setItem('clientToken', response.token);
          // this.toastService.success('Registration completed successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error during registration');
        return of(null);
      })
    );
  }


  isLogged():boolean{
    const token=localStorage.getItem('clientToken');
     
    
    return token!=null
  }

  getToken(){
    return localStorage.getItem('clientToken');
  }

   getPlacePredictions(query: string): Promise<any> {
    let autocompleteSrv = new google.maps.places.AutocompleteService();
    let placesService = new google.maps.places.PlacesService(document.createElement('div'));

    return new Promise((resolve, reject) => {
      autocompleteSrv.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: 'ma' },
          types: ['geocode']
        },
        (predictions: any, status:any) => {
          if (status == google.maps.places.PlacesServiceStatus.OK) {
            const detailedPredictions = predictions.map((prediction: any) => {
              return new Promise((resolveDetail, rejectDetail) => {
                placesService.getDetails({ placeId: prediction.place_id }, (place: any, placeStatus: any) => {
                  if (placeStatus == google.maps.places.PlacesServiceStatus.OK) {
                    prediction.lat = place.geometry.location.lat();
                    prediction.lng = place.geometry.location.lng();
                    resolveDetail(prediction);
                  } else {
                    rejectDetail(placeStatus);
                  }
                });
              });
            });
            Promise.all(detailedPredictions).then(resolve).catch(reject);
          } else {
            // this.toastService.error('Error searching for address');
            reject(status);
          }
        }
      );
    });
  }


  getDistanceDuration(origin: string, destination: string) {
    const url = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${origin}&destinations=${destination}&key=${environment.apiKeyGoogleMap}`;
    return this._httpClient.get<any>(url)
    .pipe(
      catchError((error) => {
        // this.toastService.error('Error calculating distance');
        return of(null);
      })
    );
  }

  loadProfile(imageName:string): string {
    return `https://api.kech.cab/images/${imageName}?bearer=${this.getToken()}`;
  }
  loadProfile2(imageName:string): string {
    return `${this.TAXI_BLADI_URL}/images/${imageName}?bearer=${this.getToken()}`;
  }

  increaseWallet(body: any): Observable<any> {
    return this._httpClient
    .post<any>( this.WALLET_BLADI_URL+'/v0/wallet/increase', body)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('Wallet top-up successful');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error topping up wallet');
        return of(null);
      }))
  }

  checkPin(pin: string): Observable<any> {
    const url = `${this.WALLET_BLADI_URL}/v0/wallet/check/codePin`;
    const body = { password: pin };
    return this._httpClient.post<any>(url, body)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('PIN code verified successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Invalid PIN code');
        return of(null);
      })
    );
  }
  submitPin(body: any): Observable<any> {
    const url = `${this.WALLET_BLADI_URL}/v0/wallet/otp/submit`;
    return this._httpClient.post<any>(url, body)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('PIN code submitted successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error submitting PIN code');
        return of(null);
      })
    );
  }

  sendOTP(): Observable<any> {
    const url = `${this.WALLET_BLADI_URL}/v0/wallet/otp/request`;
    return this._httpClient.post<any>(url, {}).pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('OTP sent successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error sending OTP');
        return of(null);
      })
    );

  }
  getUserInfo():Observable<any> {
    return this._httpClient.get<any>(`${this.TAXI_BLADI_URL}/profiles/client/info`)

    .pipe(
      map(response => {

        console.log("USER INFO ===> ", response);
     return response;
      }),
      catchError((error) => {
        this.logout();
        // this.toastService.error('Error retrieving user information');
        return of(null);
      })
    );
  }

  logout(){
    // localStorage.removeItem('clientToken');
    this.router.navigate(['/']);
  }

  fetchCmiData(data: any): Observable<any> {
    console.log('PAY SPECIAL DATA ==> ', data);
    return this._httpClient
      .post(this.COMMERCE_BACKEND_URL + 'serve', data, {
        headers: new HttpHeaders({
          path: 'wetaxi_wci',
        }),
      })
      .pipe(
        catchError((err) => {
          console.log('error while paying ==> ', err);
          return of(null);
        }),
        tap((response: any) => {
          console.log('Payment Intent RESPONSE ==> ', response);
          return response;
        })
      );
  }

  cancelTrip(tripId: string): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/cancel/${tripId}`;
    return this._httpClient.put<any>(url, 
      {
    "orderId": tripId,
    "cancelReason": "Client cancelled the trip to make a new trip"
}
    ).pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('Trip cancelled successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error cancelling trip');
        return of(null);
      })
    );
  }


  passTripByCmi(data:any){

    return this._httpClient
      .post(this.COMMERCE_BACKEND_URL + 'serve', data, {
      headers: new HttpHeaders({
        path: 'wetaxi_trip',
      }),
      })
      .pipe(
      tap((response: any) => {
        console.log('Trip payment response:', response);
        return response;
      })
      );

  }


  notifyDrivers(tripId: string): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/notify`;
    return this._httpClient.post<any>(url, {orderId: tripId});
  }

  feedbackDriver(feedbackData: Review): Observable<Review> {
    const url = `${this.TAXI_BLADI_URL}/trips/feedback`;
    return this._httpClient.post<Review>(url, feedbackData);
  }
  getActiveTrip(): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/active`;
    return this._httpClient.get<any>(url)
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('Active trip retrieved successfully');
        }
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
  acceptDriverByClient(ticketId:string,offerId:string): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/validate`;
    return this._httpClient.post<any>(url, {id: ticketId, offerId: offerId})
    .pipe(
      tap((response) => {
        if (response.success) {
          // this.toastService.success('Driver accepted successfully');
        }
      }),
      catchError((error) => {
        // this.toastService.error('Error accepting driver');
        return of(null);
      })
    );
  }

  applyCustomPrice(amount:number, ticketId: string): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/update`;
    return this._httpClient.post<any>(url, {amount: amount,id: ticketId})

  }
  getOffersByTripId(tripId:string,page:number): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/offers/${tripId}?page=${page}`;
    return this._httpClient.get<any>(url)
  }
  getTicketSearch(ticketId:string): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/search/${ticketId}`;
    return this._httpClient.get<any>(url)
  }

  cancelSearch(ticketId: string, reason: string = 'Client cancelled the search'): Observable<any> {
    const url = `${this.TAXI_BLADI_URL}/trips/cancel-search/${ticketId}`;
    return this._httpClient.post<any>(url, {
      reason: reason,
      cancelledAt: new Date().toISOString()
    }).pipe(
      tap((response) => {
        if (response.success) {
          console.log('Search cancelled successfully');
          // Émettre l'événement d'annulation
          this.emitCancelSearch(ticketId);
        }
      }),
      catchError((error) => {
        console.error('Error cancelling search:', error);
        return of(null);
      })
    );
  }

  /**
   * Émettre un événement d'annulation de recherche
   * @param ticketId - ID du ticket
   */
  emitCancelSearch(ticketId: string): void {
    this.cancelSearchSubject.next(ticketId);
  }

  /**
   * Émettre la liste des drivers acceptés
   * @param drivers - Tableau des drivers
   */
  emitListDriversAccepted(drivers: any[]): void {
    this.listDriversAcceptedSubject.next(drivers);
  }



}